export const genderGroups = [
  { id: 'female', label: '女性', value: '0' },
  { id: 'male', label: '男性', value: '1' },
  { id: 'other', label: 'その他', value: '2' },
  { id: 'DeclineToAnswer', label: '無回答', value: '3' },
];
